/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum ExportMonitoringEntriesQueryControllerExportSortBy {
  alert = "alert",
  location = "location",
  value = "value",
  triggered = "triggered",
  status = "status",
  resolved = "resolved",
}
